















































































import { Vue, Component } from 'vue-property-decorator';
import { Form as ElForm } from 'element-ui';
import * as amplitude from 'amplitude-js';
import {
  StoryPagesDTO,
  StoryPagesDTOStatusEnum,
} from '@/api';
import services from '@/services';
import { throwError, fileReader, getAuthToken } from '@/utils';
import UserMenu from '@/components/UserMenu.vue';
import MainNavbar from '@/components/MainNavbar.vue';
import Upload from '@/components/common/Upload.vue';
import Promo from '@/components/PromoPreview.vue';
import Story from '@/components/StoryPreview.vue';
import axios from 'axios';
import Editor from './editor.vue';

// eslint-disable-next-line import/no-webpack-loader-syntax
import htmlTemplate from '!raw-loader!./storyTemplate.html';

@Component({
  name: 'promo-story',
  components: {
    UserMenu,
    MainNavbar,
    Upload,
    Promo,
    Story,
    Editor,
  },
})
export default class PromoStory extends Vue {
  $refs!: {
    form: ElForm
  }

  loading = false;

  loadingImg = false;

  story: StoryPagesDTO | null = null;

  selectedTab: number | string | null = null;

  imgLink = '';

  form = {
    title: '',
    status: StoryPagesDTOStatusEnum.DRAFT,
  }

  newHTMLPages: string[] = [];

  get statuses() {
    return Object.values(StoryPagesDTOStatusEnum);
  }

  get pagesValue() {
    return Object.values(this.story?.pages || {});
  }

  async created() {
    amplitude.getInstance().logEvent('Открыта страница историй', this.$route.params.id);
    try {
      this.loading = true;
      if (!Number.isNaN(Number(this.$route.params.id))) {
        const { data: story } = await services.storiesApi()
          .storiesEndpointGetStory(Number(this.$route.params.id));
        this.story = story;
        this.form.title = story.title;
        this.form.status = story.status;
        const keys = Object.keys(story.pages || {});
        this.selectedTab = keys[0] ? String(keys[0]) : 'newPage';
      }
    } catch (e) {
      throwError('Ошибка')(e);
    } finally {
      this.loading = false;
    }
  }

  async handleStoriesTabsEdit(targetName: string, action: 'add' | 'remove') {
    if (this.story?.pages) {
      if (action === 'remove') {
        const [type, index] = targetName.split('_');
        if (type === 'page') {
          this.removePage(index);
        }
        if (type === 'newPage') {
          this.newHTMLPages.splice(Number(index), 1);
        }
      }
    }
  }

  async savePage(name: number, html: string) {
    if (this.story?.id != null) {
      await services.storiesApi().storiesEndpointStoreHtml(this.story.id, name, html);
    }
  }

  async saveNewPage(index: number) {
    if (this.story) {
      if (!this.story.pages) {
        this.story.pages = {};
      }
      const keys = Object.keys(this.story.pages);
      const first = Number(keys[keys.length - 1]);
      const newTabName = first ? first + 1 : 1;
      await this.savePage(newTabName, this.newHTMLPages[index]);
      amplitude.getInstance().logEvent('Сохранение истории', { newTabName, newHTMLPages: this.newHTMLPages });
      this.story.pages[String(newTabName)] = this.newHTMLPages[index];
      this.newHTMLPages.splice(index, 1);
    }
  }

  addNewPage() {
    this.newHTMLPages.push(htmlTemplate);
  }

  async uploadImage(files: File[]) {
    const file = files[0] || null;
    if (file) {
      this.loadingImg = true;
      try {
        const binary = await fileReader(file);
        const { data } = await axios.post<string>(`https://rest.styleconcierge.ru/api/story/uploadBackground/${file.name}`, binary, {
          headers: { 'Content-Type': 'application/octet-stream', Authorization: `Bearer ${getAuthToken()}` },
        });
        this.imgLink = data;
        this.copyImageLink();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      } finally {
        this.loadingImg = false;
      }
    }
  }

  copyImageLink() {
    navigator.clipboard.writeText(this.imgLink).then(() => {
      this.$notify({
        title: 'Ссылка на изображение скопирована',
        message: 'Вставьте в необходимом месте',
      });
    });
  }

  removePage(name: string) {
    this.$confirm('Вы уверены, что хотите удалить данную страницу?', 'Внимание!', {
      confirmButtonText: 'Удалить',
      cancelButtonText: 'Отмена',
      type: 'warning',
    }).then(() => {
      if (this.story) {
        // if (name === this.selectedTab) {
        // // if (keys.length === 1) {
        // //   this.selectedTab = 'newPage;';
        // // } else {
        // //   this.selectedTab = String(keys[keys.length - 1]);
        // // }
        //   this.selectedTab = 'newPage;';
        // }
        services.storiesApi().storiesEndpointDeletePage(this.story.id, Number(name));
        this.$delete(this.story.pages, Number(name));
      }
    });
  }

  createStory() {
    this.$refs.form.validate((valid) => {
      if (valid) {
        services.storiesApi()
          .storiesEndpointStoreStory(this.story?.id, this.form.status, this.form.title)
          .then(({ data }) => data)
          .then((data) => {
            this.story = {
              id: data,
              title: this.form.title,
              status: this.form.status,
              pages: this.story?.pages || {},
            };
          })
          .catch((e) => {
            this.$message.error(e);
          })
          .finally(() => { this.loading = false; });
      }
    });
  }
}
